import dayjs from "dayjs";
import {
  PlannerSlot,
  slotDay,
  slotUnavailableReason,
} from "@/components/appointmentRequest/assignmentPlanner/assignmentPlan";

export const calendarSlotIsUsable = (slot: PlannerSlot) => {
  const reason = slotUnavailableReason(slot);
  return reason === null || reason === "reserved";
};
export function plannerCalendarRows(slots: PlannerSlot[]) {
  const days = slots.map(slotDay).sort();
  if (!days.length) return [];
  const firstSlotDay = dayjs(days[0]);
  const lastSlotDay = dayjs(days[days.length - 1]);
  const firstContextMonday = firstSlotDay.subtract(
    ((firstSlotDay.day() + 6) % 7) + 7,
    "day",
  );
  const lastContextMonday = lastSlotDay
    .subtract((lastSlotDay.day() + 6) % 7, "day")
    .add(7, "day");
  const rows = new Map<
    string,
    { key: string; month: string; start: string; days: (string | null)[] }
  >();
  for (
    let monday = firstContextMonday;
    !monday.isAfter(lastContextMonday);
    monday = monday.add(7, "day")
  ) {
    const weekStart = monday.format("YYYY-MM-DD");
    for (let index = 0; index < 7; index++) {
      const month = monday.add(index, "day").format("YYYY-MM");
      const key = `${month}-${weekStart}`;
      if (!rows.has(key))
        rows.set(key, {
          key,
          month,
          start: weekStart,
          days: Array.from({ length: 7 }, (_, column) => {
            const date = monday.add(column, "day");
            return date.format("YYYY-MM") === month
              ? date.format("YYYY-MM-DD")
              : null;
          }),
        });
    }
  }
  return [...rows.values()];
}
